import { style } from "@vanilla-extract/css";
import { cellStyles } from "plos/src/components/Table/tables.css";
import { borderedCell, breakpoints, vars } from "plos/src/styles";

export const availabilityTablePlayerCol = style({
  width: "50%",
  "@media": {
    [`(min-width: ${breakpoints[4]})`]: {
      width: "30%",
    },
  },
});

export const availabilityTableStatusCol = style({
  width: "50%",
  "@media": {
    [`(min-width: ${breakpoints[4]})`]: {
      width: "70%",
    },
  },
});

export const availabilityTablePlayerCell = style([
  cellStyles,
  borderedCell,
  {
    display: "flex",
    alignItems: "center",
    padding: 0,
  },
]);

export const availabilityTableCell = style([
  cellStyles,
  {
    padding: `0 ${vars.space.xs}`,
    textWrap: "wrap",
  },
]);
